var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 12.2573V1.1579C11.6667 0.518416 11.1443 0 10.5 0C9.85568 0 9.33334 0.518416 9.33334 1.1579V12.2573L5.49162 8.44447C5.03602 7.99226 4.29733 7.99226 3.84172 8.44447C3.38609 8.89666 3.38609 9.62979 3.84172 10.082L10.5 16.6902L17.1584 10.082C17.6139 9.62979 17.6139 8.89666 17.1584 8.44447C16.7027 7.99229 15.964 7.99229 15.5083 8.44447L11.6667 12.2573Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 15.0527C1.81099 15.0527 2.33333 15.5712 2.33333 16.2106V18.0633C2.33333 18.9586 3.0646 19.6843 3.96667 19.6843H17.0333C17.9354 19.6843 18.6667 18.9586 18.6667 18.0633V16.2106C18.6667 15.5712 19.1891 15.0527 19.8333 15.0527C20.4776 15.0527 21 15.5712 21 16.2106V18.0633C21 20.2376 19.2241 22.0002 17.0333 22.0002H3.96667C1.77595 22.0002 0 20.2376 0 18.0633V16.2106C0 15.5712 0.52234 15.0527 1.16667 15.0527Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/_download.e7cd1981f573abcc8f16ec561c15ad65.svg";
export { ForwardRef as ReactComponent };